import PropTypes from 'prop-types';
import React from 'react';
import EmptyStates from '../empty-states';
import withTranslate from '../../hoc/with-translate';

const AccountSuspended = ({ t, ...props }) =>
  <EmptyStates
    title={t('account-suspended.account-suspended')}
    content={t('account-suspended.contact-owner')}
    {...props}
  />;

AccountSuspended.propTypes = {
  t: PropTypes.func.isRequired,
};

export default withTranslate(AccountSuspended);



// WEBPACK FOOTER //
// ./app/components/account-suspended/account-suspended.js